import {
  PropertyCompanyAddressType,
  propertyCompanyAddressSchema,
} from '../../../../common/validations'

export const isPropertyCompanyAddressValid = (
  address: PropertyCompanyAddressType | null
) => {
  const validation = propertyCompanyAddressSchema.safeParse(address)
  return (
    validation.success &&
    validation.data.streetAddressLine1 &&
    validation.data.postalCode &&
    validation.data.city
  )
}
